(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mba-viewing-guide"] && !Shopify.designMode) return;
  try {
    
function initMbaViewingForms(root) {
  root.querySelectorAll('form[data-mba-viewing-email]').forEach(function(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    var submit = form.querySelector('button[type="submit"]');
    var result = form.querySelector('[data-viewing-result]');
    var emailLink = form.querySelector('[data-viewing-email-link]');
    var summary = form.querySelector('[data-viewing-summary]');
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      var values = new FormData(form);
      var brief = ['Hong Kong private art viewing request', '', 'Name: ' + values.get('contact[name]'), 'Email: ' + values.get('contact[email]'), '', 'Artwork title and link:', values.get('contact[Artwork title and product link]'), '', 'Preferred date and time: ' + values.get('contact[Preferred date and time]'), '', 'Questions: ' + (values.get('contact[Questions and requests]') || 'None'), '', 'I understand the appointment is subject to artwork availability and confirmation.'].join(String.fromCharCode(10));
      emailLink.href = 'mailto:info@magicbear-art.com?subject=Hong%20Kong%20Private%20Art%20Viewing%20Request&body=' + encodeURIComponent(brief);
      summary.value = brief;
      result.hidden = false;
      result.focus();
    });
    form.addEventListener('input', function() { result.hidden = true; });
    submit.disabled = false;
  });
}
initMbaViewingForms(document);
document.addEventListener('shopify:section:load', function(event) { initMbaViewingForms(event.target); });

  } catch(e) { console.error(e); }
})();
})();
